module.exports = __webpack_public_path__ + "static/img/right-cov.556c3f39.png";